export default __webpack_public_path__ + "images/3_2_image.jpg";